module.exports = __webpack_public_path__ + "static/media/SF_nn_sentrert_logo_troendelag_pos.1f24a98c.png";